import _ from 'lodash';
import {filterVolumes} from '../components/cvs/cvsUtils'

/* eslint default-case: 0 */

export default (state = { deleteVolumeErrors: {}, volumes: [] }, { payload, type }) => {
    switch (type) {
        case "CVS-MANAGEMENT:SAVE-REGION-DATA": {
            return { ...state, regionsData: payload.regionsData };
        }
        case "CVS-MANAGEMENT:SET-SOURCE": {
            return { ...state, isFromUi: true };
        }
        case "CVS-MANAGEMENT:FIRST-FETCH-VOLUMES-PENDING": {
            return { ...state, loadingData: state.volumes.length === 0, fetchVolumesError: null };
        }
        case "CVS-MANAGEMENT:FETCH-VOLUMES-DONE": {
            const volumes = payload.volumes.map(volume => ({ ...volume, provider: "aws" }));
            return {
                ...state,
                volumes,
                filteredVolumes: filterVolumes(volumes, state.volumesFilterPhrase),
                fetchVolumesError: payload.errors,
                loadingData: false
            };
        }
        case "CVS-MANAGEMENT:FETCH-VOLUME": {
            return { ...state, loadingData: true, fetchedVolume: null };
        }
        case "CVS-MANAGEMENT:FETCH-VOLUME-SUCCESS": {
            const fetchedVolume = _.head(payload.volume);
            const volumeObj = _.find(state.volumes, {fileSystemId: fetchedVolume.fileSystemId});
            fetchedVolume.name = volumeObj.name;
            return { ...state, loadingData: false, fetchedVolume };
        }
        case "CVS-MANAGEMENT:FETCH-VOLUME-ERROR": {
            return { ...state, loadingData: false, fetchedVolumeError: payload.error };
        }
        case "CVS-MANAGEMENT:CREATE-VOLUME-PENDING": {
            return {
                ...state,
                loadingData: state.volumes.length === 0,
                createVolumeError: null,
                isVolumeCreating: true
            };
        }
        case "CVS-MANAGEMENT:CREATE-VOLUME-SUCCESS": {
            const volumesWithNewVolume = state.volumes ? state.volumes.concat(payload.volume) : null;
            return {
                ...state,
                loadingData: false,
                isVolumeCreating: false,
                volumes: volumesWithNewVolume,
                filteredVolumes: filterVolumes(volumesWithNewVolume, state.volumesFilterPhrase)
            };
        }
        case "CVS-MANAGEMENT:CREATE-VOLUME-ERROR": {
            return { ...state, createVolumeError: payload, loadingData: false, isVolumeCreating: false };
        }
        case "CVS-MANAGEMENT:OPEN-CONFIRM-DELETE-DIALOG": {
            return { ...state, volumeToDelete: payload.volumeToDelete };
        }
        case "CVS-MANAGEMENT:CLOSE-CONFIRM-DELETE-DIALOG": {
            return { ...state, volumeToDelete: null };
        }
        case "CVS-MANAGEMENT:DELETE-VOLUME-PENDING": {
            return {
                ...state,
                loadingData: state.volumes.length === 0,
                deleteVolumeErrors: { ...state.deleteVolumeErrors, [payload.volumeId]: null },
                volumeToDelete: null
            };
        }
        case "CVS-MANAGEMENT:DELETE-VOLUME-SUCCESS": {
            const volumesWithoutDeleted = _.reject(state.volumes, { fileSystemId: payload.deletedVolume.fileSystemId });
            return {
                ...state,
                loadingData: false,
                volumes: volumesWithoutDeleted,
                filteredVolumes: filterVolumes(volumesWithoutDeleted, state.volumesFilterPhrase)
            };
        }
        case "CVS-MANAGEMENT:DELETE-VOLUME-ERROR": {
            return {
                ...state,
                deleteVolumeErrors: { ...state.deleteVolumeErrors, [payload.volumeId]: payload.error },
                loadingData: false
            };
        }
        case "CVS-MANAGEMENT:SET-VOLUME-FILTER": {
            return {
                ...state,
                volumesFilterPhrase: payload.value.toLowerCase(),
                filteredVolumes: filterVolumes(state.volumes, payload.value.toLowerCase())
            };
        }
    }

    return state;
};
